// extracted by css-extract-rspack-plugin
export default {"root":"dZWtbv","cover":"RjxTkZ","middle":"kdy7Pt","mature-block-middle":"cUE9on","matureBlockMiddle":"cUE9on","underlay":"UftfQL","mature-block":"VJxtLs","matureBlock":"VJxtLs"};